import { AdminHeader } from "@/components/AdminHeader";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { MailCheck, MailWarning } from "lucide-react";

export default function EmailsTab() {
  const [emails, setEmails] = useState(null);

  useEffect(() => {
    api.get("/admin/emails").then((r) => setEmails(r.data)).catch(() => setEmails([]));
  }, []);

  if (emails === null) return <p className="text-muted-foreground font-ui">Loading email log…</p>;

  return (
    <div data-testid="admin-emails-tab">
      <AdminHeader testid="admin-header-emails" eyebrow="System" title="Emails" description="Log of every email the system has sent." />
      <div className="space-y-4">
      {emails.length === 0 ? (
        <p data-testid="emails-empty" className="text-muted-foreground font-ui">No emails sent yet.</p>
      ) : (
        emails.map((e) => (
          <div key={e.id} data-testid={`email-row-${e.id}`} className="bg-white shadow-[0_8px_30px_rgba(0,0,0,0.04)] rounded-2xl p-5 flex items-start gap-4">
            {e.sent ? (
              <MailCheck size={18} className="text-emerald-600 shrink-0 mt-0.5" />
            ) : (
              <MailWarning size={18} className="text-amber-600 shrink-0 mt-0.5" />
            )}
            <div className="min-w-0">
              <p className="font-ui font-medium truncate">{e.subject}</p>
              <p className="text-sm text-muted-foreground font-ui">To: {e.to}</p>
              <p className="text-xs text-muted-foreground font-ui mt-1">
                {new Date(e.created_at).toLocaleString()} · {e.sent ? "Sent via SMTP" : "Logged (SMTP not configured)"}
                {e.error ? ` · Error: ${e.error}` : ""}
              </p>
            </div>
          </div>
        ))
      )}
      </div>
    </div>
  );
}
